import { useEffect, useState } from "react";
import { useApp } from "@/App";

export function useRubTopupAvailability() {
  const { api, user } = useApp();
  const [availability, setAvailability] = useState(null);
  const userId = user?.id;
  useEffect(() => {
    let cancelled = false;
    setAvailability(null);
    if (userId) {
      api.get("/rub-topup/config").then(({ data }) => {
        if (!cancelled) setAvailability({ userId, enabled: data?.enabled === true });
      }).catch(() => {});
    }
    return () => { cancelled = true; };
  }, [api, userId]);
  return availability?.userId === userId && availability?.enabled === true;
}
